/*! modernizr 3.3.1 (Custom Build) | MIT *
 * https://modernizr.com/download/?-csscalc-csstransforms-csstransitions-cssvhunit-cssvmaxunit-cssvminunit-cssvwunit-displaytable-flexbox-objectfit-opacity-supports-svg-mq-setclasses-shiv !*/ !function(e, t, n) {
    function r(e, t) {
        return typeof e === t;
    }
    function i() {
        var e, t, n, i, o, a, s;
        for(var l in C)if (C.hasOwnProperty(l)) {
            if (e = [], t = C[l], t.name && (e.push(t.name.toLowerCase()), t.options && t.options.aliases && t.options.aliases.length)) for(n = 0; n < t.options.aliases.length; n++)e.push(t.options.aliases[n].toLowerCase());
            for(i = r(t.fn, "function") ? t.fn() : t.fn, o = 0; o < e.length; o++)a = e[o], s = a.split("."), 1 === s.length ? Modernizr[s[0]] = i : (!Modernizr[s[0]] || Modernizr[s[0]] instanceof Boolean || (Modernizr[s[0]] = new Boolean(Modernizr[s[0]])), Modernizr[s[0]][s[1]] = i), S.push((i ? "" : "no-") + s.join("-"));
        }
    }
    function o(e) {
        var t = E.className, n = Modernizr._config.classPrefix || "";
        if (N && (t = t.baseVal), Modernizr._config.enableJSClass) {
            var r = new RegExp("(^|\\s)" + n + "no-js(\\s|$)");
            t = t.replace(r, "$1" + n + "js$2");
        }
        Modernizr._config.enableClasses && (t += " " + n + e.join(" " + n), N ? E.className.baseVal = t : E.className = t);
    }
    function a() {
        return "function" != typeof t.createElement ? t.createElement(arguments[0]) : N ? t.createElementNS.call(t, "http://www.w3.org/2000/svg", arguments[0]) : t.createElement.apply(t, arguments);
    }
    function s(e, t) {
        return e - 1 === t || e === t || e + 1 === t;
    }
    function l() {
        var e = t.body;
        return e || (e = a(N ? "svg" : "body"), e.fake = !0), e;
    }
    function d(e, n, r, i) {
        var o, s, d, c, u = "modernizr", f = a("div"), p = l();
        if (parseInt(r, 10)) for(; r--;)d = a("div"), d.id = i ? i[r] : u + (r + 1), f.appendChild(d);
        return o = a("style"), o.type = "text/css", o.id = "s" + u, (p.fake ? p : f).appendChild(o), p.appendChild(f), o.styleSheet ? o.styleSheet.cssText = e : o.appendChild(t.createTextNode(e)), f.id = u, p.fake && (p.style.background = "", p.style.overflow = "hidden", c = E.style.overflow, E.style.overflow = "hidden", E.appendChild(p)), s = n(f, e), p.fake ? (p.parentNode.removeChild(p), E.style.overflow = c, E.offsetHeight) : f.parentNode.removeChild(f), !!s;
    }
    function c(e) {
        return e.replace(/([a-z])-([a-z])/g, function(e, t, n) {
            return t + n.toUpperCase();
        }).replace(/^-/, "");
    }
    function u(e, t) {
        return !!~("" + e).indexOf(t);
    }
    function f(e, t) {
        return function() {
            return e.apply(t, arguments);
        };
    }
    function p(e, t, n) {
        var i;
        for(var o in e)if (e[o] in t) return n === !1 ? e[o] : (i = t[e[o]], r(i, "function") ? f(i, n || t) : i);
        return !1;
    }
    function m(e) {
        return e.replace(/([A-Z])/g, function(e, t) {
            return "-" + t.toLowerCase();
        }).replace(/^ms-/, "-ms-");
    }
    function h(t, r) {
        var i = t.length;
        if ("CSS" in e && "supports" in e.CSS) {
            for(; i--;)if (e.CSS.supports(m(t[i]), r)) return !0;
            return !1;
        }
        if ("CSSSupportsRule" in e) {
            for(var o = []; i--;)o.push("(" + m(t[i]) + ":" + r + ")");
            return o = o.join(" or "), d("@supports (" + o + ") { #modernizr { position: absolute; } }", function(e) {
                return "absolute" == getComputedStyle(e, null).position;
            });
        }
        return n;
    }
    function v(e, t, i, o) {
        function s() {
            d && (delete L.style, delete L.modElem);
        }
        if (o = r(o, "undefined") ? !1 : o, !r(i, "undefined")) {
            var l = h(e, i);
            if (!r(l, "undefined")) return l;
        }
        for(var d, f, p, m, v, g = [
            "modernizr",
            "tspan",
            "samp"
        ]; !L.style && g.length;)d = !0, L.modElem = a(g.shift()), L.style = L.modElem.style;
        for(p = e.length, f = 0; p > f; f++)if (m = e[f], v = L.style[m], u(m, "-") && (m = c(m)), L.style[m] !== n) {
            if (o || r(i, "undefined")) return s(), "pfx" == t ? m : !0;
            try {
                L.style[m] = i;
            } catch (y) {}
            if (L.style[m] != v) return s(), "pfx" == t ? m : !0;
        }
        return s(), !1;
    }
    function g(e, t, n, i, o) {
        var a = e.charAt(0).toUpperCase() + e.slice(1), s = (e + " " + M.join(a + " ") + a).split(" ");
        return r(t, "string") || r(t, "undefined") ? v(s, t, i, o) : (s = (e + " " + F.join(a + " ") + a).split(" "), p(s, t, n));
    }
    function y(e, t, r) {
        return g(e, n, n, t, r);
    }
    var S = [], C = [], x = {
        _version: "3.3.1",
        _config: {
            classPrefix: "",
            enableClasses: !0,
            enableJSClass: !0,
            usePrefixes: !0
        },
        _q: [],
        on: function(e, t) {
            var n = this;
            setTimeout(function() {
                t(n[e]);
            }, 0);
        },
        addTest: function(e, t, n) {
            C.push({
                name: e,
                fn: t,
                options: n
            });
        },
        addAsyncTest: function(e) {
            C.push({
                name: null,
                fn: e
            });
        }
    }, Modernizr = function() {};
    Modernizr.prototype = x, Modernizr = new Modernizr, Modernizr.addTest("svg", !!t.createElementNS && !!t.createElementNS("http://www.w3.org/2000/svg", "svg").createSVGRect);
    var w = "CSS" in e && "supports" in e.CSS, b = "supportsCSS" in e;
    Modernizr.addTest("supports", w || b);
    var E = t.documentElement, N = "svg" === E.nodeName.toLowerCase();
    N || !function(e, t) {
        function n(e, t) {
            var n = e.createElement("p"), r = e.getElementsByTagName("head")[0] || e.documentElement;
            return n.innerHTML = "x<style>" + t + "</style>", r.insertBefore(n.lastChild, r.firstChild);
        }
        function r() {
            var e = S.elements;
            return "string" == typeof e ? e.split(" ") : e;
        }
        function i(e, t) {
            var n = S.elements;
            "string" != typeof n && (n = n.join(" ")), "string" != typeof e && (e = e.join(" ")), S.elements = n + " " + e, d(t);
        }
        function o(e) {
            var t = y[e[v]];
            return t || (t = {}, g++, e[v] = g, y[g] = t), t;
        }
        function a(e, n, r) {
            if (n || (n = t), u) return n.createElement(e);
            r || (r = o(n));
            var i;
            return i = r.cache[e] ? r.cache[e].cloneNode() : h.test(e) ? (r.cache[e] = r.createElem(e)).cloneNode() : r.createElem(e), !i.canHaveChildren || m.test(e) || i.tagUrn ? i : r.frag.appendChild(i);
        }
        function s(e, n) {
            if (e || (e = t), u) return e.createDocumentFragment();
            n = n || o(e);
            for(var i = n.frag.cloneNode(), a = 0, s = r(), l = s.length; l > a; a++)i.createElement(s[a]);
            return i;
        }
        function l(e, t) {
            t.cache || (t.cache = {}, t.createElem = e.createElement, t.createFrag = e.createDocumentFragment, t.frag = t.createFrag()), e.createElement = function(n) {
                return S.shivMethods ? a(n, e, t) : t.createElem(n);
            }, e.createDocumentFragment = Function("h,f", "return function(){var n=f.cloneNode(),c=n.createElement;h.shivMethods&&(" + r().join().replace(/[\w\-:]+/g, function(e) {
                return t.createElem(e), t.frag.createElement(e), 'c("' + e + '")';
            }) + ");return n}")(S, t.frag);
        }
        function d(e) {
            e || (e = t);
            var r = o(e);
            return !S.shivCSS || c || r.hasCSS || (r.hasCSS = !!n(e, "article,aside,dialog,figcaption,figure,footer,header,hgroup,main,nav,section{display:block}mark{background:#FF0;color:#000}template{display:none}")), u || l(e, r), e;
        }
        var c, u, f = "3.7.3", p = e.html5 || {}, m = /^<|^(?:button|map|select|textarea|object|iframe|option|optgroup)$/i, h = /^(?:a|b|code|div|fieldset|h1|h2|h3|h4|h5|h6|i|label|li|ol|p|q|span|strong|style|table|tbody|td|th|tr|ul)$/i, v = "_html5shiv", g = 0, y = {};
        !function() {
            try {
                var e = t.createElement("a");
                e.innerHTML = "<xyz></xyz>", c = "hidden" in e, u = 1 == e.childNodes.length || function() {
                    t.createElement("a");
                    var e = t.createDocumentFragment();
                    return "undefined" == typeof e.cloneNode || "undefined" == typeof e.createDocumentFragment || "undefined" == typeof e.createElement;
                }();
            } catch (n) {
                c = !0, u = !0;
            }
        }();
        var S = {
            elements: p.elements || "abbr article aside audio bdi canvas data datalist details dialog figcaption figure footer header hgroup main mark meter nav output picture progress section summary template time video",
            version: f,
            shivCSS: p.shivCSS !== !1,
            supportsUnknownElements: u,
            shivMethods: p.shivMethods !== !1,
            type: "default",
            shivDocument: d,
            createElement: a,
            createDocumentFragment: s,
            addElements: i
        };
        e.html5 = S, d(t), "object" == typeof module && module.exports && (module.exports = S);
    }("undefined" != typeof e ? e : this, t);
    var T = x._config.usePrefixes ? " -webkit- -moz- -o- -ms- ".split(" ") : [
        "",
        ""
    ];
    x._prefixes = T, Modernizr.addTest("csscalc", function() {
        var e = "width:", t = "calc(10px);", n = a("a");
        return n.style.cssText = e + T.join(t + e), !!n.style.length;
    }), Modernizr.addTest("opacity", function() {
        var e = a("a").style;
        return e.cssText = T.join("opacity:.55;"), /^0.55$/.test(e.opacity);
    });
    var _ = function() {
        var t = e.matchMedia || e.msMatchMedia;
        return t ? function(e) {
            var n = t(e);
            return n && n.matches || !1;
        } : function(t) {
            var n = !1;
            return d("@media " + t + " { #modernizr { position: absolute; } }", function(t) {
                n = "absolute" == (e.getComputedStyle ? e.getComputedStyle(t, null) : t.currentStyle).position;
            }), n;
        };
    }();
    x.mq = _;
    var z = x.testStyles = d;
    z("#modernizr{display: table; direction: ltr}#modernizr div{display: table-cell; padding: 10px}", function(e) {
        var t, n = e.childNodes;
        t = n[0].offsetLeft < n[1].offsetLeft, Modernizr.addTest("displaytable", t, {
            aliases: [
                "display-table"
            ]
        });
    }, 2), z("#modernizr { height: 50vh; }", function(t) {
        var n = parseInt(e.innerHeight / 2, 10), r = parseInt((e.getComputedStyle ? getComputedStyle(t, null) : t.currentStyle).height, 10);
        Modernizr.addTest("cssvhunit", r == n);
    }), z("#modernizr1{width: 50vmax}#modernizr2{width:50px;height:50px;overflow:scroll}#modernizr3{position:fixed;top:0;left:0;bottom:0;right:0}", function(t) {
        var n = t.childNodes[2], r = t.childNodes[1], i = t.childNodes[0], o = parseInt((r.offsetWidth - r.clientWidth) / 2, 10), a = i.clientWidth / 100, l = i.clientHeight / 100, d = parseInt(50 * Math.max(a, l), 10), c = parseInt((e.getComputedStyle ? getComputedStyle(n, null) : n.currentStyle).width, 10);
        Modernizr.addTest("cssvmaxunit", s(d, c) || s(d, c - o));
    }, 3), z("#modernizr1{width: 50vm;width:50vmin}#modernizr2{width:50px;height:50px;overflow:scroll}#modernizr3{position:fixed;top:0;left:0;bottom:0;right:0}", function(t) {
        var n = t.childNodes[2], r = t.childNodes[1], i = t.childNodes[0], o = parseInt((r.offsetWidth - r.clientWidth) / 2, 10), a = i.clientWidth / 100, l = i.clientHeight / 100, d = parseInt(50 * Math.min(a, l), 10), c = parseInt((e.getComputedStyle ? getComputedStyle(n, null) : n.currentStyle).width, 10);
        Modernizr.addTest("cssvminunit", s(d, c) || s(d, c - o));
    }, 3), z("#modernizr { width: 50vw; }", function(t) {
        var n = parseInt(e.innerWidth / 2, 10), r = parseInt((e.getComputedStyle ? getComputedStyle(t, null) : t.currentStyle).width, 10);
        Modernizr.addTest("cssvwunit", r == n);
    });
    var j = "Moz O ms Webkit", M = x._config.usePrefixes ? j.split(" ") : [];
    x._cssomPrefixes = M;
    var k = function(t) {
        var r, i = T.length, o = e.CSSRule;
        if ("undefined" == typeof o) return n;
        if (!t) return !1;
        if (t = t.replace(/^@/, ""), r = t.replace(/-/g, "_").toUpperCase() + "_RULE", r in o) return "@" + t;
        for(var a = 0; i > a; a++){
            var s = T[a], l = s.toUpperCase() + "_" + r;
            if (l in o) return "@-" + s.toLowerCase() + "-" + t;
        }
        return !1;
    };
    x.atRule = k;
    var F = x._config.usePrefixes ? j.toLowerCase().split(" ") : [];
    x._domPrefixes = F;
    var I = {
        elem: a("modernizr")
    };
    Modernizr._q.push(function() {
        delete I.elem;
    });
    var L = {
        style: I.elem.style
    };
    Modernizr._q.unshift(function() {
        delete L.style;
    }), x.testAllProps = g, x.testAllProps = y, Modernizr.addTest("flexbox", y("flexBasis", "1px", !0)), Modernizr.addTest("csstransforms", function() {
        return -1 === navigator.userAgent.indexOf("Android 2.") && y("transform", "scale(1)", !0);
    }), Modernizr.addTest("csstransitions", y("transition", "all", !0));
    var P = x.prefixed = function(e, t, n) {
        return 0 === e.indexOf("@") ? k(e) : (-1 != e.indexOf("-") && (e = c(e)), t ? g(e, t, n) : g(e, "pfx"));
    };
    Modernizr.addTest("objectfit", !!P("objectFit"), {
        aliases: [
            "object-fit"
        ]
    }), i(), o(S), delete x.addTest, delete x.addAsyncTest;
    for(var A = 0; A < Modernizr._q.length; A++)Modernizr._q[A]();
    e.Modernizr = Modernizr;
}(window, document);

//# sourceMappingURL=about.56401677.js.map
